import { render, staticRenderFns } from "./InventoryStockIn.vue?vue&type=template&id=5d1ffc7f&"
import script from "./InventoryStockIn.vue?vue&type=script&lang=js&"
export * from "./InventoryStockIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports